import { ActionReducerMap } from '@ngrx/store';
import { addNewAccountStoreDataType } from './core/models/Interfaces/addNewAccount';
import { companyStateDataType } from './core/models/Interfaces/company';
import { createPasswordStoreData } from './core/models/Interfaces/createPassword';
import { forgotPasswordStoreData } from './core/models/Interfaces/forgotPassword';
import { loginStoreData } from './core/models/Interfaces/login';
import { addNewAccountReducer } from './state/reducers/addNewAccountReducer';
import { companyReducer } from './state/reducers/companyReducer';
import { createPasswordReducer } from './state/reducers/createPasswordReducer';
import { forgotPasswordReducer } from './state/reducers/forgotPasswordReducer';
import { loginReducer } from './state/reducers/loginReducer';
import { docuementsReducer } from './state/reducers/documentsTabReducer';
import { documentStateType } from './core/models/Interfaces/documents';
import { vehicleReducer } from './state/reducers/vehicleReducer';
import { vehicleStateDataType } from './core/models/Interfaces/vehicle';
import { operatingAuthorityReducer } from './state/reducers/operatingAuthorityReducer';
import { operatingAuthityStateDataType } from './core/models/Interfaces/operatingAuthority';
import { operatingAuthorityApplicationReducer } from './state/reducers/operatingAuthorityApplicationReducer';
import { operatingAuthorityApplicationStateDataType } from './core/models/Interfaces/operatingAuthorityApplication';

export interface State {
  login: loginStoreData;
  forgotPassword: forgotPasswordStoreData;
  createPassword: createPasswordStoreData;
  company: companyStateDataType;
  addNewAccount: addNewAccountStoreDataType;
  documents: documentStateType;
  vehicle: vehicleStateDataType;
  operatingAuthority: operatingAuthityStateDataType;
  operatingAuthorityApplication: operatingAuthorityApplicationStateDataType;
}

export const store: ActionReducerMap<State> = {
  login: loginReducer,
  forgotPassword: forgotPasswordReducer,
  createPassword: createPasswordReducer,
  company: companyReducer,
  addNewAccount: addNewAccountReducer,
  documents: docuementsReducer,
  vehicle: vehicleReducer,
  operatingAuthority: operatingAuthorityReducer,
  operatingAuthorityApplication: operatingAuthorityApplicationReducer,
};
